// extracted by mini-css-extract-plugin
export default {"seoText":"_3pHyi","seoTextShowButton":"_6NZP3"};